import React from 'react'
import {
  Box,
  LinearProgress,
  Step,
  StepLabel,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import SignupStyledStepper from './styled-stepper'
import SignupStepIcon from './check-step-icon'

const useStyles = makeStyles(theme => ({
  mobileRoot: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  mobileLabel: {
    fontWeight: 600,
    minWidth: 0,
  },
  progress: {
    height: 6,
    borderRadius: 3,
  },
}))

function resolveProgressValue({
  activeStep,
  steps,
  progressStep,
  progressStepCount,
}) {
  const total = progressStepCount != null ? progressStepCount : steps.length
  const current =
    progressStep != null
      ? progressStep
      : Math.min(Math.max(activeStep, 0), Math.max(total - 1, 0))

  if (total <= 0) return 0
  return ((Math.min(current, total - 1) + 1) / total) * 100
}

function MobileStepProgress({
  steps,
  activeStep,
  progressStep,
  progressStepCount,
}) {
  const classes = useStyles()
  const labelIndex = Math.min(
    Math.max(activeStep, 0),
    Math.max(steps.length - 1, 0),
  )
  const label = steps[labelIndex]
  const progressValue = resolveProgressValue({
    activeStep,
    steps,
    progressStep,
    progressStepCount,
  })

  return (
    <Box className={classes.mobileRoot}>
      <Typography
        variant="subtitle1"
        className={classes.mobileLabel}
        noWrap
        title={label}
        gutterBottom
      >
        {label}
      </Typography>
      <LinearProgress
        className={classes.progress}
        variant="determinate"
        value={progressValue}
        aria-label={`Registration progress: ${label}`}
      />
    </Box>
  )
}

/**
 * Registration progress: full labeled stepper on sm+, compact label + bar on xs.
 *
 * Optional progressStep / progressStepCount drive the mobile bar by real screen
 * index (e.g. each player-registration page), while steps/activeStep stay phase labels.
 */
export default function SignupStepProgress({
  steps,
  activeStep,
  progressStep,
  progressStepCount,
}) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  if (isMobile) {
    return (
      <MobileStepProgress
        steps={steps}
        activeStep={activeStep}
        progressStep={progressStep}
        progressStepCount={progressStepCount}
      />
    )
  }

  return (
    <SignupStyledStepper alternativeLabel activeStep={activeStep}>
      {steps.map(step => (
        <Step key={step}>
          <StepLabel StepIconComponent={SignupStepIcon}>{step}</StepLabel>
        </Step>
      ))}
    </SignupStyledStepper>
  )
}
